/* eslint-disable @typescript-eslint/naming-convention */
import { VehicleBlockActivityInfo } from './vehicle-block-activity-info';

import * as _ from 'lodash';

export class VehicleBlock {
    vehicleActivities: VehicleBlockActivityInfo[];

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }

        if (this.vehicleActivities) {
            this.vehicleActivities = _.map(this.vehicleActivities, v => new VehicleBlockActivityInfo(v));
        }
    }
}
